import React, { type SVGAttributes } from 'react';

export type SvgProps = SVGAttributes<SVGElement>;

export function Svg({
  fill = 'var(--mi-icon-color)',
  stroke = 'none',
  width = '24',
  height = width,
  viewBox = `0 0 ${width} ${height}`,
  ...props
}: SVGAttributes<SVGElement>) {
  return <svg width={width} height={height} viewBox={viewBox} role="img" fill={fill} stroke={stroke} {...props} />;
}
